import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BellIcon } from "@phosphor-icons/react";

import { getMonitoringStats } from "../../lib/monitoring";

export default function MonitoringKpiTile() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getMonitoringStats()
      .then((d) => {
        if (cancelled) return;
        setStats(d);
      })
      .catch(() => {
        // silent degrade
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const totalNew = stats?.total_new ?? 0;
  const totalCritical = stats?.total_critical ?? 0;

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => navigate("/monitoring?status=new")}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          navigate("/monitoring?status=new");
        }
      }}
      data-testid="monitoring-kpi-tile"
      className="bg-white border border-slate-200 rounded-md p-5 hover:border-amber-400 hover:shadow-sm cursor-pointer transition"
    >
      <div className="flex items-center justify-between">
        <div className="text-[11px] uppercase tracking-wider text-slate-500 font-bold">
          New Alerts
        </div>
        <BellIcon size={18} className="text-amber-600" />
      </div>
      <div className="mt-2">
        {loading ? (
          <div className="h-9 w-12 bg-slate-100 rounded animate-pulse" />
        ) : stats === null ? (
          <div className="text-3xl font-bold text-slate-300">—</div>
        ) : (
          <div className="text-3xl font-bold text-slate-900">{totalNew}</div>
        )}
      </div>
      {stats !== null && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            navigate("/monitoring?severity=critical");
          }}
          data-testid="monitoring-kpi-critical"
          className={`mt-2 text-[11px] uppercase tracking-wider font-semibold transition ${
            totalCritical > 0
              ? "text-red-700 hover:text-red-900"
              : "text-slate-400"
          }`}
        >
          {totalCritical} critical
        </button>
      )}
    </div>
  );
}
